const PERSONAL_FOLDER_SHARE_TYPE: string = "0";
const DEPARTMENT_FOLDER_SHARE_TYPE: string = "1";
const COMPANY_FOLDER_SHARE_TYPE: string = "2";

export class MyCatalogRegisterJsEnv {
  isError: boolean;
  errorCode: string;
  isDisplayDepartmentFolders: boolean;
  isDisplayCompanyFolders: boolean;
  personalFolders: PersonalFolder[];
  departmentFolders: DepartmentFolder[];
  companyFolders: CompanyFolder[];
  registeredFolderCodes: number[];

  constructor(
    isError: boolean,
    errorCode: string,
    isDisplayDepartmentFolders: boolean,
    isDisplayCompanyFolders: boolean,
    personalFolders: PersonalFolder[],
    departmentFolders: DepartmentFolder[],
    companyFolders: CompanyFolder[],
    registeredFolderCodes: number[]
  ) {
    this.isError = isError;
    this.errorCode = errorCode;
    this.isDisplayDepartmentFolders = isDisplayDepartmentFolders;
    this.isDisplayCompanyFolders = isDisplayCompanyFolders;
    this.personalFolders = personalFolders;
    this.departmentFolders = departmentFolders;
    this.companyFolders = companyFolders;
    this.registeredFolderCodes = registeredFolderCodes;
  }

  static error(response: any) {
    console.log(response);
    console.log(response.response.data.errors[0].code);
    return new MyCatalogRegisterJsEnv(
      true,
      response.response.data.errors[0].code,
      false,
      false,
      [],
      [],
      [],
      []
    );
  }

  /// APIのレスポンスからオブジェクトを生成
  static success(response: any) {
    const personalFolders: PersonalFolder[] = this.convertPersonalFolders(response.personalFolders);
    const departmentFolders: DepartmentFolder[] = this.convertDepartmentFolders(response.departmentFolders);
    const companyFolders: CompanyFolder[] = this.convertCompanyFolders(response.companyFolders);

    return new MyCatalogRegisterJsEnv(
      false,
      "",
      Boolean(response.canDisplayDepartmentFolders),
      Boolean(response.canDisplayCompanyFolders),
      personalFolders ?? [],
      departmentFolders ?? [],
      companyFolders ?? [],
      response.registeredFolderCodes ?? []
    );
  }

  /// 個人フォルダ一覧オブジェクトをPersonalFolderに変換
  private static convertPersonalFolders(personalFolders: any): PersonalFolder[] {
    return personalFolders?.map((personalFolder) => {
      return new PersonalFolder(
        new FolderInformation(
          personalFolder.folderInformation.folderCode,
          personalFolder.folderInformation.folderName,
          personalFolder.folderInformation.folderItemCount,
          personalFolder.folderInformation.folderManagerId
        ) ,
        this.convertChildFavoriteListFolders(personalFolder.childFavoriteListFolders ?? [])
      );
    });
  }

  /// 部門共有フォルダ一覧オブジェクトをDepartmentFolderに変換
  private static convertDepartmentFolders(departmentFolders: any): DepartmentFolder[] {
    return departmentFolders?.map((departmentFolder) => {
      return new DepartmentFolder(
        new FolderInformation(
          departmentFolder.folderInformation.folderCode,
          departmentFolder.folderInformation.folderName,
          departmentFolder.folderInformation.folderItemCount,
          departmentFolder.folderInformation.folderManagerId
        ) ,
        this.convertChildFavoriteListFolders(departmentFolder.childFavoriteListFolders ?? [])
      );
    });
  }

  /// 企業共有フォルダ一覧オブジェクトをCompanyFolderに変換
  private static convertCompanyFolders(companyFolders: any): CompanyFolder[] {
    return companyFolders?.map((companyFolder) => {
      return new CompanyFolder(
        new FolderInformation(
          companyFolder.folderInformation.folderCode,
          companyFolder.folderInformation.folderName,
          companyFolder.folderInformation.folderItemCount,
          companyFolder.folderInformation.folderManagerId
        ) ,
        this.convertChildFavoriteListFolders(companyFolder.childFavoriteListFolders ?? [])
      );
    });
  }

  /// 子フォルダ一覧オブジェクトをChildFavoriteListFolderに変換
  private static convertChildFavoriteListFolders(childFavoriteListFolders: any): ChildFavoriteListFolder[] {
    return childFavoriteListFolders?.map((childFavoriteListFolder) => {
      return new ChildFavoriteListFolder(
        new FolderInformation(
          childFavoriteListFolder.folderInformation.folderCode,
          childFavoriteListFolder.folderInformation.folderName,
          childFavoriteListFolder.folderInformation.folderItemCount,
          childFavoriteListFolder.folderInformation.folderManagerId
        ) ,
        this.convertGrandChildFavoriteListFolders(childFavoriteListFolder.grandChildFavoriteListFolders ?? [])
      );
    });
  }

  /// 孫フォルダ一覧オブジェクトをGrandChildFavoriteListFolderに変換
  private static convertGrandChildFavoriteListFolders(grandChildFavoriteListFolders: any): GrandChildFavoriteListFolder[] {
    return grandChildFavoriteListFolders?.map((grandChildFavoriteListFolder) => {
      return new GrandChildFavoriteListFolder(
        new FolderInformation(
          grandChildFavoriteListFolder.folderCode,
          grandChildFavoriteListFolder.folderName,
          grandChildFavoriteListFolder.folderItemCount,
          grandChildFavoriteListFolder.folderManagerId
        )
      );
    });
  }
}

export class PersonalFolder implements ParentFolder {
  folderInformation: FolderInformation;
  childFavoriteListFolders: ChildFavoriteListFolder[];
  folderShareType: string;

  constructor(
    folderInformation: FolderInformation,
    childFavoriteListFolders: ChildFavoriteListFolder[],
  ) {
    this.folderInformation = folderInformation;
    this.childFavoriteListFolders = childFavoriteListFolders;
    this.folderShareType = PERSONAL_FOLDER_SHARE_TYPE;
  }
}

export class DepartmentFolder implements ParentFolder {
  folderInformation: FolderInformation;
  childFavoriteListFolders: ChildFavoriteListFolder[];
  folderShareType: string;

  constructor(
    folderInformation: FolderInformation,
    childFavoriteListFolders: ChildFavoriteListFolder[],
  ) {
    this.folderInformation = folderInformation;
    this.childFavoriteListFolders = childFavoriteListFolders;
    this.folderShareType = DEPARTMENT_FOLDER_SHARE_TYPE;
  }
}

export class CompanyFolder implements ParentFolder {
  folderInformation: FolderInformation;
  childFavoriteListFolders: ChildFavoriteListFolder[];
  folderShareType: string;

  constructor(
    folderInformation: FolderInformation,
    childFavoriteListFolders: ChildFavoriteListFolder[],
  ) {
    this.folderInformation = folderInformation;
    this.childFavoriteListFolders = childFavoriteListFolders;
    this.folderShareType = COMPANY_FOLDER_SHARE_TYPE;
  }
}

export class ChildFavoriteListFolder {
  folderInformation: FolderInformation;
  grandChildFavoriteListFolders: GrandChildFavoriteListFolder[];

  constructor(
    folderInformation: FolderInformation,
    grandChildFavoriteListFolders: GrandChildFavoriteListFolder[],
  ) {
    this.folderInformation = folderInformation;
    this.grandChildFavoriteListFolders = grandChildFavoriteListFolders;
  }
}

export class GrandChildFavoriteListFolder {
  folderInformation: FolderInformation;

  constructor(
    folderInformation: FolderInformation,
  ) {
    this.folderInformation = folderInformation;
  }
}

export class FolderInformation {
  folderCode: number;
  folderName: string;
  folderItemCount: number;
  folderManagerId: string;

  constructor(
    folderCode: number,
    folderName: string,
    folderItemCount: number,
    folderManagerId: string
  ) {
    this.folderCode = folderCode;
    this.folderName = folderName;
    this.folderItemCount = folderItemCount;
    this.folderManagerId = folderManagerId;
  }
}

export interface ParentFolder {
  folderInformation: FolderInformation;
  childFavoriteListFolders: ChildFavoriteListFolder[];
  folderShareType: string;
}
